import React, { useState, useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-tjIjLI8L.js';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import { extractVariantsFromProductName, formatProductName } from './utils/product.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import useItemListName from './hooks/useItemListName.js';
import { getProductImage, getProductNewPrice, getProductOldPrice, getCartItemStockInfo, getCartSessionId } from './utils/cart.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';
import Loader from './components/Loader/index.js';
import { Q as Quantity } from './Quantity-dEUUtuvu.js';
import { R as Remove } from './Remove-yBvNmlSV.js';

const ShoppingCartItemDrawer = ({ item }) => {
    var _a, _b;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const router = useRouter();
    const [isDeleting, setIsDeleting] = useState(false);
    const { data: { siteConfig: { noZeroAfterDecimal = false }, }, thunks: { cart: { removeItem }, }, useDispatch, } = useContext(CoreContext);
    const { price } = item.prices;
    const currencyCode = price.currency;
    const locale = router.locale;
    const { data: { siteConfig: { productNameFilters, accorTagging: { accorTaggingEnabled = false } = {} }, }, } = useContext(CoreContext);
    const itemListName = useItemListName('mini basket');
    const { url: imgUrl, label: imgAlt } = getProductImage(item);
    const newPrice = getProductNewPrice(item, currencyCode, locale, noZeroAfterDecimal, item.quantity);
    const oldPrice = getProductOldPrice(item, currencyCode, locale, noZeroAfterDecimal, item.quantity);
    const dispatch = useDispatch();
    const showError = useShowError();
    const stockInfo = getCartItemStockInfo(item, t);
    const stockInfoMessageVariant = stockInfo.qty < item.quantity || !stockInfo.availableForSale ? 'error' : 'info';
    const remove = async () => {
        setIsDeleting(true);
        const cartSessionId = getCartSessionId();
        const payload = {
            cart_id: cartSessionId,
            cart_item_id: Number(item.id),
            cart_item: item,
            accorTaggingEnabled,
            itemListName,
        };
        const resultAction = await dispatch(removeItem(payload));
        if (removeItem.rejected.match(resultAction)) {
            showError(resultAction.payload.errorMessage);
        }
        setIsDeleting(false);
    };
    if (!item.quantity)
        return null;
    const variants = extractVariantsFromProductName({
        name: ((_a = item.configured_variant) === null || _a === void 0 ? void 0 : _a.name) || ((_b = item.product) === null || _b === void 0 ? void 0 : _b.name),
    });
    const variantsArray = variants ? variants.split(/;| - /) : [];
    return (React.createElement("li", { className: "cart-item" },
        React.createElement("div", { className: "image" },
            React.createElement("img", { src: imgUrl, alt: imgAlt, onError: () => logImgLoadErrorToRelic(router.asPath, imgUrl) })),
        React.createElement("div", { className: "inner-wrapper" },
            React.createElement("div", { className: "description" },
                React.createElement("div", { className: "item-title" }, formatProductName({
                    name: item.product.name,
                    lang: locale,
                    siteFilters: productNameFilters || null,
                })),
                React.createElement("div", { className: "item-options" }, variantsArray.length > 0 &&
                    variantsArray
                        .map((variant) => variant ? (React.createElement("span", { className: "product-option test1", key: variant }, variant)) : null)
                        .filter(Boolean)),
                stockInfo.message && (React.createElement("div", { className: `stock-level ${stockInfoMessageVariant}-ui`, role: "alert" }, stockInfo.message))),
            React.createElement("div", { className: "inner-wrapper" },
                React.createElement(Quantity, { item: item }),
                React.createElement("div", { className: "price" },
                    React.createElement("span", { className: "cart-title" },
                        tLabel('price'),
                        ": "),
                    React.createElement("div", { className: "price-wrapper" },
                        oldPrice && oldPrice !== newPrice && (React.createElement(React.Fragment, null,
                            React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.originalPrice')),
                            React.createElement("div", { className: "product-price old strike", "aria-label": `${tLabel('originalPrice')}: ${oldPrice}` }, oldPrice),
                            React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.price')))),
                        newPrice && (React.createElement("div", { className: "product-price", "aria-label": `${tLabel('price')}: ${newPrice}` }, newPrice)))))),
        React.createElement("div", { className: "remove" }, isDeleting ? (React.createElement(Loader, { size: 20 })) : (React.createElement(Remove, { item: item, onRemove: remove, icon: "icon-close" })))));
};

export { ShoppingCartItemDrawer as S };
//# sourceMappingURL=ShoppingCartItemDrawer-FsPUBjBK.js.map
